import React from "react";
import blueIndicatorIcon from "@src/assets/svg/blue-indicator-icon.svg";
import { ActiveInstallationProcessPayload } from "@src/types/ota-update";
import styles from "./ota-backup-process-in-progress-modal.module.scss";
import { useOtaBackupProcessInProgressModal } from "./use-ota-backup-process-in-progress-modal";
import { ScanLoadingLinearIndicator } from "@src/components/molecules/scan-loading-linear-indicator/scan-loading-linear-indicator";
import { Button } from "@src/components/atoms/buttons/button/button";

const cssClassName = "ota-backup-process-in-progress-modal";

interface OTABackupProcessInProgressModalProps {
  activeInstallationData: ActiveInstallationProcessPayload;
  onClose: () => void;
}

const OTABackupProcessInProgressModal = ({
  activeInstallationData,
  onClose,
}: OTABackupProcessInProgressModalProps) => {
  const { texts, backupDetails, folders, installationProgressSteps } =
    useOtaBackupProcessInProgressModal(activeInstallationData);
  const stepsToBeRenderedBeforeFolders = installationProgressSteps.slice(0, 2);
  const stepsToBeRenderedAfterFolders = installationProgressSteps.slice(2);

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__overlay`]} />
      <div className={styles[`${cssClassName}__dialog-wrapper`]}>
        <div
          className={styles[`${cssClassName}__modal-body`]}
          role="dialog"
          aria-modal="true"
        >
          <div className={styles[`${cssClassName}__header`]}>
            <h2 className={styles[`${cssClassName}__title`]}>{texts.title}</h2>
            {backupDetails ? (
              <p className={styles[`${cssClassName}__backup-details`]}>
                {backupDetails}
              </p>
            ) : null}
          </div>

          <div className={styles[`${cssClassName}__content`]}>
            <div
              className={styles[`${cssClassName}__installation-progress-steps`]}
            >
              {stepsToBeRenderedBeforeFolders.map((step, index) => (
                <div key={index} className={styles[`${cssClassName}__step`]}>
                  <img src={blueIndicatorIcon} alt="" />
                  <span>{step}</span>
                </div>
              ))}
            </div>

            {folders.length > 0 && (
              <div className={styles[`${cssClassName}__folders-card`]}>
                {folders.map((folder) => (
                  <div
                    key={folder}
                    className={styles[`${cssClassName}__folder-row`]}
                  >
                    <img src={blueIndicatorIcon} alt="" />
                    <span className={styles[`${cssClassName}__folder-name`]}>
                      \{folder}
                    </span>
                  </div>
                ))}
              </div>
            )}

            <div
              className={styles[`${cssClassName}__installation-progress-steps`]}
            >
              {stepsToBeRenderedAfterFolders.map((step, index) => (
                <div
                  key={`after-${index}`}
                  className={styles[`${cssClassName}__step`]}
                >
                  <img src={blueIndicatorIcon} alt="" />
                  <span>{step}</span>
                </div>
              ))}
            </div>

            <ScanLoadingLinearIndicator />
          </div>

          <div className={styles[`${cssClassName}__buttons-wrapper`]}>
            <Button
              fun={onClose}
              text={texts.pushInBackgroundButtonText}
              variant="primary"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTABackupProcessInProgressModal;
